export default function AppSection() {
  return (
    <section id="app" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-accent-500 blur-3xl"></div>
          </div>
          <div className="flex-1 relative z-10 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-background-50 font-heading mb-3">
              每日大瓜 APP
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-5">
              随时随地吃瓜不迷路。APP 端支持推送通知，大瓜第一时间送达，离线也能刷往期深扒，夜间模式护眼追瓜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-semibold rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill"></i>
                iOS 下载
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-50/40 text-background-50 font-semibold rounded-lg hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="relative z-10 w-48 h-48 md:w-56 md:h-56 flex-shrink-0">
            <div className="w-full h-full rounded-2xl bg-background-50/15 backdrop-blur flex items-center justify-center">
              <i className="ri-fire-line text-6xl text-background-50/60"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}